package com.nonopn.skywatcher.common.app.pages.map.window

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.view.AlertBannerShowOrHide
import com.nonopn.skywatcher.common.app.pages.map.view.MainColumn
import com.nonopn.skywatcher.common.app.pages.map.view.Map
import com.nonopn.skywatcher.design.widgets.CustomHorizontalPager

@Composable
fun MainScreenTinyScreen(
    modifier: Modifier,
    model: MainScreenModel
) {
    Row(modifier) {
        val state = rememberPagerState(1) { 2 }
        CustomHorizontalPager(
            Modifier.fillMaxSize(),
            state
        ) { page, paddingBottom ->
            if (page == 0) {
                MainColumn(
                    Modifier.fillMaxSize(),
                    model,
                    paddingBottom
                ) {
                    AlertBannerShowOrHide(Modifier.fillMaxWidth().height(300.dp), model)
                }
                /*} else if (page == 1) {
                    AlertBanner(
                        Modifier.fillMaxWidth().height(300.dp),
                        model
                    )*/
            } else {
                Map(
                    Modifier.fillMaxSize().padding(bottom = paddingBottom),
                    model
                )
            }
        }
    }
}